export default window._cmsContent['whd/summary']